import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgNoInsurance = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.5 5.405c1.552.038 3.454-.049 4.263-.619 1.474-1.038 1.636-.824 2.822.498 1.185 1.322 5.775 2.34 5.775 2.34s-.685 5.33-3.744 9.376M5.02 9c.11 3.716 1.065 9.27 5.414 12.194A9.893 9.893 0 0 0 13.5 19.92M4.18 4.498 17.82 21.9"
      stroke="#D0021B"
    />
  </svg>
);
const Memo = memo(SvgNoInsurance);
export default Memo;
